<template>
<div style="border: 1px solid #ccc;" class="song">
  <slot></slot>
  <v-list-item>
    <v-list-item-content >
      <v-list-item-title >
         {{song.name}}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ song.author }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</div>
</template>

<script>
export default {
   props: {
    song: {
      type: Object,
      required: true,
    },
    
  },
  
};
</script>
<style scoped>
.song{
  display:flex;
  align-items: center;
}

</style>